import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AboutPageComponent} from './about-page/about-page.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FaqPageComponent} from './faq-page/faq-page.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import { ContactUsComponent } from './contact-us/contact-us.component';
import {ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatButtonModule} from '@angular/material/button';
import { HomeComponent } from './home/home.component';
import {InViewportModule} from 'ng-in-viewport';
import {CountUpModule} from 'ngx-countup';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
  declarations: [
    AboutPageComponent,
    FaqPageComponent,
    ContactUsComponent,
    HomeComponent
  ],
  exports: [AboutPageComponent, FaqPageComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatTabsModule,
    MatExpansionModule,
    ReactiveFormsModule,
    InputTextModule,
    InputTextareaModule,
    FontAwesomeModule,
    MatButtonModule,
    InViewportModule,
    CountUpModule,
    TranslateModule
  ]
})
export class PagesModule {
}
